// @ts-strict-ignore
import React from 'react'
import FormatCurrency from '../../utils/currency-formater'
import { CURRENCY_SIMBOL } from '../../constants'
import { Button } from '@uswitch/ev-components/lib/components/elements/trustyle-button'
import { calculateTotalInterestAndPeriod } from 'rvu-mortgages-calculations'

const getFeeOptions = () => {
  const arr = []

  for (let i = 0; i <= 50; i++) {
    arr.push(i)
  }

  const range = arr.map((n) => ({
    text: `${n / 10}  %`,
    value: n / 10,
  }))
  return range
}

const monthOptions = [...Array(99)].map((_, index) => ({
  text: index + 1,
  value: index + 1,
}))

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const getFormattedDate = (value: any) =>
  new Date(new Date().setMonth(new Date().getMonth() + value))

const calculateBalanceTransferFee = (balance, fee, amount, months, apr) => {
  const newBalance = balance * (1 + fee / 100) - amount * months
  const resultnew = calculateTotalInterestAndPeriod(newBalance, apr, amount)
  return resultnew
}

const CreditCardCalculator = () => {
  const data = {
    balance: '3500',
    apr: 18,
    amount: '95',
    months: 24,
    fee: 1.4,
    cardOffBalance: 1585,
    errorMessage: '',
  }

  const result = calculateTotalInterestAndPeriod(
    parseFloat(data.balance.replace(/,/g, '')),
    data.apr,
    parseFloat(data.amount.replace(/,/g, '')),
  )

  const formattedDate = getFormattedDate(result.period)

  const BTresult = calculateBalanceTransferFee(
    parseFloat(data.balance.replace(/,/g, '')),
    data.fee,
    parseFloat(data.amount.replace(/,/g, '')),
    data.months,
    data.apr,
  )

  const dueDatePeriod = getFormattedDate(BTresult.period + +data.months)

  const cardOffBalance = BTresult.total + data.months * +data.amount

  return (
    <div data-controller='credit-card-calculator'>
      <div>
        <h1 className='CreditCardCalculator__title'>Credit card interest calculator</h1>
        <h3 className='CreditCardCalculator__subtitle'>
          Find the total cost of your credit card and how long it will take to pay off.
        </h3>
      </div>
      <div className='CreditCardCalculator__body'>
        <form data-action='credit-card-calculator#submit' className='CreditCardCalculator__form'>
          <div className='CreditCardCalculator__body__field'>
            <label htmlFor={'balance'} className='CreditCardCalculator__body__field__input__label'>
              Card balance
            </label>
            <div className='CreditCardCalculator__body__field__input'>
              <div>
                <span className='CreditCardCalculator__body__field__input__label--symbol'>£</span>
                <input
                  className='CreditCardCalculator__body__field__input__box'
                  type='text'
                  min={0}
                  value={String(FormatCurrency(data.balance))}
                  name='balance'
                  data-credit-card-calculator-target='balanceInput'
                />
              </div>
            </div>
          </div>
          <div className='CreditCardCalculator__body__field'>
            <label htmlFor={'apr'} className='CreditCardCalculator__body__field__input__label'>
              Card APR
            </label>
            <div className='CreditCardCalculator__body__field__input'>
              <input
                className='CreditCardCalculator__body__field__input__box'
                type='number'
                value={String(data.apr)}
                name='apr'
                data-credit-card-calculator-target='aprInput'
                step='0.1'
              />
              <span>%</span>
            </div>
          </div>
          <div>
            <div className='CreditCardCalculator__body__field'>
              <label htmlFor={'amount'} className='CreditCardCalculator__body__field__input__label'>
                Monthly repayment
              </label>
              <div className='CreditCardCalculator__body__field__input'>
                <span className='CreditCardCalculator__body__field__input__label--symbol'>£</span>
                <input
                  className='CreditCardCalculator__body__field__input__box'
                  type='text'
                  min={0}
                  value={String(FormatCurrency(data.amount))}
                  name='amount'
                  data-credit-card-calculator-target='amountInput'
                />
              </div>
            </div>
            <span data-credit-card-calculator-target='errors'></span>
          </div>
          <div className='CreditCardCalculator__body__field__cta'>
            <Button
              type='submit'
              variant='secondary'
              disabled={!data.balance || !data.apr || !data.amount}
              style={{ width: '100%' }}
            >
              Recalculate
            </Button>
          </div>
        </form>
        <div className='CreditCardCalculator__body__results'>
          <div className='CreditCardCalculator__body__results__text'>
            <span className='CreditCardCalculator__body__results__textStyle'>
              Total repayable over{' '}
              <span data-credit-card-calculator-target='repaying'>{result.period} months </span>
            </span>
            <span
              className='CreditCardCalculator__body__results__textBold'
              data-credit-card-calculator-target='amount'
            >
              {` ${CURRENCY_SIMBOL}${FormatCurrency(+result.total, 'GBP', CURRENCY_SIMBOL)}`}
              {/* {FormatCurrency(+result.total, 'GBP', CURRENCY_SIMBOL)} */}
            </span>
          </div>
          <div className='CreditCardCalculator__body__results__dueDate'>
            <span className='CreditCardCalculator__body__results__textStyle'>
              Final payment due
            </span>
            <span
              className='CreditCardCalculator__body__results__textBold'
              data-credit-card-calculator-target='dueDate'
            >
              {' '}
              {monthNames[formattedDate.getMonth()]} {formattedDate.getFullYear()}
            </span>
          </div>
        </div>
        <h3 className='CreditCardCalculator__body__bt'>
          Transfering your debt onto a{' '}
          <span className='CreditCardCalculator__body__bt__bold'>0% balance transfer card</span>{' '}
          could save you money:
        </h3>
        <div className='CreditCardCalculator__body__transfer'>
          <div className='CreditCardCalculator__body__field'>
            <label
              htmlFor={'months'}
              className='CreditCardCalculator__body__transfer__input__label'
            >
              {' '}
              Months
            </label>
            <select
              className='CreditCardCalculator__body__field__input__box CreditCardCalculator__body__field__input__box__bt'
              name='months'
              value={data.months}
              data-credit-card-calculator-target='monthInput'
              data-action='change->credit-card-calculator#changeCalcInput'
            >
              {monthOptions.map((month) => (
                <option value={`${month.value}`}>{month.text}</option>
              ))}
            </select>
          </div>
          <div className='CreditCardCalculator__body__field'>
            <label htmlFor={'fee'} className='CreditCardCalculator__body__transfer__input__label'>
              Fee
            </label>
            <select
              className='CreditCardCalculator__body__field__input__box CreditCardCalculator__body__field__input__box__bt'
              name='fee'
              value={data.fee}
              data-credit-card-calculator-target='feeInput'
              data-action='change->credit-card-calculator#changeCalcInput'
            >
              {' '}
              {getFeeOptions().map((val) => {
                return <option value={`${val.value}`}>{val.text}</option>
              })}
            </select>
          </div>
        </div>
        <div className='CreditCardCalculator__body__results__dueDate'>
          <h3 className='CreditCardCalculator__body__results__textStyle'>You could save</h3>
          <h3
            data-credit-card-calculator-target='savings'
            className='CreditCardCalculator__body__results__textBold'
          >{`£${FormatCurrency(Math.ceil(+result.total - +cardOffBalance))}`}</h3>
        </div>
        <h3 className='CreditCardCalculator__body__bt'>
          By switching to a 0% balance transfer card for{' '}
          <span
            data-credit-card-calculator-target='months'
            className='CreditCardCalculator__body__bt__bold'
          >
            {data.months} months
          </span>{' '}
          and a one-off fee of{' '}
          <span
            data-credit-card-calculator-target='fee'
            className='CreditCardCalculator__body__bt__bold'
          >
            {data.fee}
          </span>
          %, you would pay your card off by{' '}
          <span
            data-credit-card-calculator-target='payOffBy'
            className='CreditCardCalculator__body__bt__bold'
          >{`${monthNames[dueDatePeriod.getMonth()]} ${dueDatePeriod.getFullYear()}`}</span>{' '}
          and pay a total of{' '}
          <span
            data-credit-card-calculator-target='totalFees'
            className='CreditCardCalculator__body__bt__bold'
          >
            £
            {FormatCurrency(Math.ceil(cardOffBalance - parseFloat(data.balance.replace(/,/g, ''))))}
          </span>{' '}
          in fees and interest.
        </h3>
        <div className='CreditCardCalculator__cta'>
          <Button type='submit' variant='primary'>
            <a href='/credit-cards/eligibility-checker?productType=BT' target='__blank'>
              See balance transfer cards
            </a>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default CreditCardCalculator
